import { Fragment, memo } from 'react'
import { Box } from '@maas-components/core'
import VariationsAutocompleteField from '../VariationsAutocompleteField'
import { IVariation, IVariationInputRendererProps } from './types'
import VariationItemView from './VariationItemView'

const VariationInputRenderer = ({
  variations,
  inputLabel,
  options,
  showAvatar = false,
  onChange,
  value,
  error,
}: IVariationInputRendererProps) => {
  const renderVariations = () => (
    <Box className="d-flex mb-3">
      {Array.isArray(variations[0]) ? (
        (variations as IVariation[][]).map((variationGroup: IVariation[], groupIndex: number) => (
          <Box className="d-flex align-center mr-3" key={groupIndex}>
            {variationGroup.map((variation: IVariation, index: number) => (
              <Fragment key={`${groupIndex}-${index}`}>
                <VariationItemView variation={variation} />
                {index !== variationGroup.length - 1 && <span className="mr-1">/</span>}
              </Fragment>
            ))}
          </Box>
        ))
      ) : (
        <Box className="d-flex align-center mr-3" key={0}>
          {(variations as IVariation[]).map((variation: IVariation, index: number) => (
            <Fragment key={index}>
              <VariationItemView variation={variation} />
              {index !== (variations as IVariation[]).length - 1 && <span className="mr-1">/</span>}
            </Fragment>
          ))}
        </Box>
      )}
    </Box>
  )
  return (
    <Box className="mt-4">
      {renderVariations()}
      <VariationsAutocompleteField
        error={!!error}
        errorMessage={error}
        value={value}
        options={options}
        inputLabel={inputLabel}
        onChange={onChange}
        showAvatar={showAvatar}
      />
    </Box>
  )
}

export default memo(VariationInputRenderer)
